import React from 'react'
import LayoutMain from '../layouts/Main'
import LayoutBase from '../layouts/Base'
import ScheduledMessages from '../components/ScheduledMessages'

export default function ScheduledMessagesPage() {
  return (
    <LayoutBase>
      <LayoutMain>
        <ScheduledMessages />
      </LayoutMain>
    </LayoutBase>
  )
}
